import { useEffect, useState } from "react";
import { Box } from "@mui/system";
import createGroup from "../../assets/images/chats/createGroup.svg";
import { CircularProgress, InputBase, Typography } from "@mui/material";

import { useTranslation } from "react-i18next";
import { requestCreatFirstGroup } from "../../appStore/actions/ArkchatGroup/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getProfile,
  profileUpdate,
} from "../../appStore/actions/profile/action";
import { REQUEST_FAILED } from "../../appStore/actions/global/type";
import FirstGroupToolTip from "../../common/ToolTip/FirstGroupToolTip";
import ExternalAccountInviteTooltip from "../../common/ToolTip/ExternalAccountInviteTooltip";
import { showToastMsg } from "../../appStore/actions/global/action";
import { CustomButton } from "../../common/CustomButtons/CustomButtons";
import { colorSchemes, fontSizeSchemes } from "../../assets/commonFunction";
const classes = {
  inputField: {
    borderBottom: "1px solid grey",
    fontSize: "0.875rem",
    width: "100%",
    textAlign: "center",
    "& input": {
      textAlign: "center",
    },
  },
  image: {
    width: "100%",
  },
  headerBox: {
    display: "flex",
    width: "100%",
    padding: "0.2rem 0rem",
    justifyContent: "center",
    backgroundColor: "#F3F3F3 !important",
  },
};

const CreateFirstGroupComponent = (setType) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const userData = useSelector((state) => state?.profile);
  const [groupName, setGroupName] = useState("Explore Arkchat");
  const [groupDesc, setGroupDesc] = useState(
    "A chat group to explore Arkchat: private group chats, instant tasks and approvals, and more tools that make teamwork simple."
  );
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);
  //
  const handleCreateGroup = async () => {
    //group_name, topic_name, subscriber_id, city, country, country_code, description, is_topic_on
    const reqBody = {
      group_name: groupName,
      subscriber_id: userData?.profileData?.data?.activeSubscriber?.id,
      topic_name: "General",
      description: "",
      city: userData?.profileData?.data?.city,
      country: userData?.profileData?.data?.country,
      country_code: userData?.profileData?.data?.countryCode,
      is_topic_on: true,
    };
    setLoading(true);
    //
    dispatch(requestCreatFirstGroup(reqBody)).then((res) => {
      setLoading(false);
      if (res?.status) {
        // Updating is_first_group_created key to keep track.
        dispatch(profileUpdate({ is_first_group_created: true }, false))
          .then((res) => {
            navigate("/invite");
          })
          .catch((err) => {
            dispatch(showToastMsg(appContent?.KEY52));
            dispatch({ type: REQUEST_FAILED, payload: err?.response });
          });
      } else {
        dispatch(showToastMsg(appContent?.KEY52));
      }
    });
  };

  return (
    <>
      {userData?.profileData &&
        !userData?.profileData?.data?.tooltipWelcomeJourneyCompletedWeb &&
        userData?.profileData?.data?.tooltipFirstInviteScreenWeb === 0 &&
        !userData?.profileData?.data?.tooltipFirstGroupScreenWeb && (
          <FirstGroupToolTip
            updateKey={"tooltip_first_group_screen_web"}
            content={[]}
          />
        )}

      {userData?.profileData &&
        !userData?.profileData?.data?.tooltipWelcomeJourneyCompletedWeb &&
        userData?.profileData?.data?.tooltipFirstInviteScreenWeb === 2 && (
          <ExternalAccountInviteTooltip />
        )}
      <Box sx={{ height: "89vh" }} position={"relative"}>
        <Box mb={4} sx={classes?.headerBox}>
          <Typography fontSize={fontSizeSchemes.font18} fontWeight={600}>
            {appContent?.KEY282}
          </Typography>
        </Box>

        <Box width={"21%"} margin={"auto"}>
          <img
            style={{ width: "290px", height: "180px" }}
            src={createGroup}
            alt="createGroup"
          />
        </Box>
        <Box mt={2}>
          <Typography
            fontSize={"0.875rem"}
            align="center"
            variant="subtitle1"
            gutterBottom
          >
            {appContent?.KEY114}
          </Typography>

          <Box width={"21%"} margin={"auto"} mt={"1.5rem"}>
            <InputBase
              id="group-name"
              value={groupName}
              sx={classes.inputField}
              placeholder="Group Name"
              onChange={(e) => setGroupName(e.target.value)}
            />
          </Box>

          <Box width={"41%"} margin={"auto"} mt={"1.5rem"}>
            <InputBase
              id="group-dec"
              value={groupDesc}
              sx={{
                ...classes.inputField,
                ".MuiInputBase-input": { textAlign: "center" },
              }}
              placeholder={appContent?.KEY284}
              onChange={(e) => setGroupDesc(e.target.value)}
              multiline
              maxRows={3}
            />
          </Box>

          <Box mt={"2rem"} textAlign="center">
            <Typography variant="body2">{appContent?.KEY283}</Typography>
          </Box>
          <Box position={"absolute"} bottom={"1rem"} width={"100%"}>
            <CustomButton
              padding={"0.5rem 2rem"}
              backgroundColor={groupName ? "#fff" : "#fff"}
              borderColor={groupName ? "#000000" : colorSchemes.lightGray}
              color={groupName ? "#000000" : "#000000"}
              handleClick={groupName ? handleCreateGroup : null}
            >
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                <Typography
                  color={groupName ? "#000000" : colorSchemes.lightGray}
                >
                  {appContent?.KEY3}
                </Typography>
              )}
            </CustomButton>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CreateFirstGroupComponent;
